export const css = {
    root: 'MBbsS6EH',
    loading: '_3HkN_yUn',
    titleBlock: '_2r44aK9d',
    title: '_2mzhFU_-',
    gotitBlock: '_1OYA-XC_',
    gotit: '_2fk-VIyS',
    section: '_2AjUw4tp',
    hero: '_1cnsud-A',
    heroBanner: '_3hUG0sb0',
    heroSubtitle: '_1SgzCHeJ',
    heroIconList: '_2lNzGHoN',
    verticalAccordion: '_1J0720Z1',
    accordion: '_2rWl9xYc',
    horizontalAccordion: '_3yvE9rnX',
    storyline: '_158CdTNe',
    xref: '_2ayQfh1q',
    HCBullet: '_2cdL9kxR',
    HCBulletStyle2: 'Bpsy_REw',
    TableUL: '_2AScZty7',
    figure: 'KyrO5Gl2',
    ph: '_3midiA0l',
    nextprev: '_3f8XC3aC',
    next: '_2XW0mwPj',
    previous: '_3C2P3XpB',
    compactyes: '_1qEsOeIS',
    ' _key': 'ascm-theme/ascm/book-widgets/topicpage'
};
export default css;
